import React, { useState } from "react";
import { Grid, Typography, Box } from "@mui/material";

const Point = ({ selected }) => (
  <Box
    sx={{
      backgroundColor: selected ? "#53D28E" : "#DDE0E5",
      width: 6,
      height: 6,
      borderRadius: 6,
      display: "inline-block",
      ml: 0.375,
    }}
  />
);

const SkillLine = ({
  skill: { level = 0, name = "", description = "No description." },
  onClick,
}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <Grid
      style={{ cursor: "pointer" }}
      onClick={onClick}
      container
      direction="column"
      sx={{
        minHeight: 23,
        height: showMore ? "auto" : 23,
        borderRadius: 1,
        backgroundColor: "#ffffff",
        border: "1px solid #EDEFF2",
        mt: 0,
        mb: 0.5,
        pl: 0,
        pr: 0.625,
        overflow: showMore ? "visible" : "hidden",
      }}
    >
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Grid item sx={{ width: 45, ml: 0.875 }}>
            <Point selected={level >= 1} />
            <Point selected={level >= 2} />
            <Point selected={level >= 3} />
            <Point selected={level >= 4} />
          </Grid>
          <Grid item xs zeroMinWidth>
            <Typography
              variant="body2"
              noWrap
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                pr: 1.25,
                pl: 1.25,
                fontSize: 10,
                color: "#202A3E",
                lineHeight: "23px",
                "&::first-letter": {
                  textTransform: "capitalize",
                },
              }}
            >
              {name}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {showMore && (
        <Grid item sx={{ minHeight: 20, width: "100%" }}>
          <Typography
            variant="body2"
            sx={{
              color: "#B4B8BF",
              fontSize: 9,
              mt: 1.125,
              pr: 1.25,
              pl: 1.25,
              lineHeight: "12px",
              whiteSpace: "normal",
              mb: 1.25,
            }}
          >
            {description}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SkillLine;
